/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.isFamiwareOffer = this.dataset.showTeaser === 'true';

        if (this.isFamiwareOffer) this.createDiscountTeaser();

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          } else if (this.dataset.trigger === 'clipboard') {
            this.copyHandler = this.copyHandler || this.handleCopy.bind(this);
            document.addEventListener('copy', this.copyHandler);
          }
        }
      }

      createDiscountTeaser() {
        const existingTeaser = document.querySelector('[data-famiware-discount-teaser]');
        if (existingTeaser && !Shopify.designMode) return;
        if (existingTeaser) existingTeaser.remove();

        const teaser = document.createElement('div');
        const allowedPositions = ['top-left', 'middle-left', 'bottom-left', 'top-right', 'middle-right', 'bottom-right'];
        const teaserPosition = allowedPositions.includes(this.dataset.teaserPosition)
          ? this.dataset.teaserPosition
          : 'middle-left';
        const allowedMobilePositions = ['bottom-left', 'bottom-center', 'bottom-right'];
        const teaserMobilePosition = allowedMobilePositions.includes(this.dataset.teaserMobilePosition)
          ? this.dataset.teaserMobilePosition
          : 'bottom-left';
        const teaserText = this.dataset.teaserText || 'Get 12% Off';
        const horizontalOffset = Number.parseInt(this.dataset.teaserHorizontalOffset, 10) || 18;
        const verticalOffset = Number.parseInt(this.dataset.teaserVerticalOffset, 10) || 24;

        teaser.className = `famiware-discount-teaser famiware-discount-teaser--${teaserPosition} famiware-discount-teaser--mobile-${teaserMobilePosition}`;
        teaser.dataset.famiwareDiscountTeaser = this.id;
        teaser.style.setProperty('--famiware-teaser-bg', this.dataset.teaserBgColor || '#33451b');
        teaser.style.setProperty('--famiware-teaser-color', this.dataset.teaserTextColor || '#ffffff');
        teaser.style.setProperty('--famiware-teaser-offset-x', `${horizontalOffset}px`);
        teaser.style.setProperty('--famiware-teaser-offset-y', `${verticalOffset}px`);

        const offerButton = document.createElement('button');
        offerButton.className = 'famiware-discount-teaser__offer';
        offerButton.type = 'button';
        offerButton.setAttribute('aria-haspopup', 'dialog');
        offerButton.setAttribute('aria-controls', this.id);
        offerButton.textContent = teaserText;

        const closeButton = document.createElement('button');
        closeButton.className = 'famiware-discount-teaser__close';
        closeButton.type = 'button';
        closeButton.setAttribute('aria-label', this.dataset.teaserCloseLabel || 'Close discount offer');
        closeButton.textContent = '×';

        teaser.append(offerButton, closeButton);
        offerButton.addEventListener('click', () => this.open());
        closeButton.addEventListener('click', () => {
          teaser.hidden = true;
          sessionStorage.setItem('famiware-discount-teaser-hidden', 'true');
        });

        if (!Shopify.designMode && sessionStorage.getItem('famiware-discount-teaser-hidden') === 'true') teaser.hidden = true;
        document.body.appendChild(teaser);
        this.discountTeaser = teaser;

        const emailInput = this.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.placeholder = 'Enter your email';
          emailInput.required = true;
          emailInput.setAttribute('aria-required', 'true');
          emailInput.addEventListener('invalid', () => {
            emailInput.setCustomValidity('Please enter your email to claim 12% off.');
          });
          emailInput.addEventListener('input', () => emailInput.setCustomValidity(''));
        }

        const signupForm = emailInput ? emailInput.closest('form') : null;
        if (signupForm && !signupForm.querySelector('.famiware-signup-fields')) {
          const extraFields = document.createElement('div');
          extraFields.className = 'famiware-signup-fields';
          extraFields.innerHTML = `
            <label class="famiware-signup-field">
              <span>First name</span>
              <input class="input w-full" type="text" name="contact[first_name]" autocomplete="given-name" placeholder="First name">
            </label>
            <fieldset class="famiware-signup-field famiware-birthday-field">
              <legend>Birthday</legend>
              <div class="famiware-birthday-inputs">
                <input class="input w-full" type="text" name="contact[birth_month]" inputmode="numeric" autocomplete="bday-month" maxlength="2" pattern="[0-9]{1,2}" placeholder="MM" aria-label="Birth month">
                <input class="input w-full" type="text" name="contact[birth_day]" inputmode="numeric" autocomplete="bday-day" maxlength="2" pattern="[0-9]{1,2}" placeholder="DD" aria-label="Birth day">
                <input class="input w-full" type="text" name="contact[birth_year]" inputmode="numeric" autocomplete="bday-year" maxlength="4" pattern="[0-9]{4}" placeholder="YYYY" aria-label="Birth year">
              </div>
            </fieldset>
          `;

          const submitButton = signupForm.querySelector('button');
          const successMessage = signupForm.querySelector('.alert');
          signupForm.insertBefore(extraFields, successMessage);

          if (submitButton) {
            submitButton.type = 'submit';
            submitButton.className = 'btn btn--primary w-full famiware-claim-button';
            submitButton.textContent = 'CLAIM 12% OFF';
            signupForm.insertBefore(submitButton, successMessage);
          }
        }

        const successAlert = this.querySelector('.alert');
        if (successAlert) {
          this.classList.add('famiware-signup-success');
          successAlert.classList.add('famiware-success-message');
          successAlert.innerHTML = `
            <h2>Your 12% Off Is Ready!</h2>
            <p>Use code <strong>FAMI12</strong> at checkout and enjoy 12% off your first order.</p>
          `;

          const modalContent = successAlert.closest('.modal__content');
          Array.from(modalContent.children).forEach((element) => {
            if (!element.contains(successAlert)) element.hidden = true;
          });
          const successForm = successAlert.closest('form');
          successForm.classList.add('famiware-success-form');
          successForm.parentElement.classList.add('famiware-success-form-wrap');
          Array.from(successForm.children).forEach((element) => {
            if (element !== successAlert) element.hidden = true;
          });
        }
      }

      open() {
        if (this.discountTeaser) this.discountTeaser.classList.add('is-popup-open');
        super.open();
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.discountTeaser && this.discountTeaser.isConnected) this.discountTeaser.remove();

        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }

        if (this.copyHandler) {
          document.removeEventListener('copy', this.copyHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'copy' events on the body.
       */
      handleCopy() {
        if (!getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, this.dataset.dismissDays);
        if (this.discountTeaser) this.discountTeaser.classList.remove('is-popup-open');
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
